import { AIParsingUsageView } from "../../../../Trips"
import { Helmet } from "react-helmet-async"

export default function AiParsing() {
	return (
		<>
			<Helmet>
				<title>Trip Quote Parsing Credits</title>
			</Helmet>
			<AIParsingUsageView />
		</>
	)
}
